module.exports = __webpack_public_path__ + "static/media/logo-amazon.8746b430.png";